<div class="store-finder-wrapper p-l-8-m p-r-8-m p-l-4-s p-r-4-s">
    <ng-container *ifSize="'XL'">
        <div class="flex flex-stretch store-locator-container">

            <!--shop  list -->
            <div class="store-finder c-4-set p-l-14-x p-l-6-l m-r-0 p-r-6 p-t-8 flex flex-column pos-relative">
                <h3 class="h3 p-b-4">{{'Find a store' | translate}}</h3>
                <ng-container *ngTemplateOutlet="searchInputAndLocation"></ng-container>
                <result [status]="status"></result>
                <div #container
                     class="overflow-y-auto flex flex-column flex-grow">
                    <ng-container *ngTemplateOutlet="searchResults"></ng-container>
                </div>
            </div>

            <!-- map -->
            <div class="flex-grow pos-relative ">
                <google-map class="fill"
                            [fitBounds]="true"
                            [stores]="findableModels"
                            [options]="googleMapOptions"
                            [markerLimit]="1000">
                </google-map>
            </div>
        </div>
    </ng-container>
    <ng-container *ifSize="'SM'">
        <div class="store-finder m-b-8 m-t-8 flex flex-column pos-relative">
            <h3 class="h3 p-b-4">{{'Find a store' | translate}}</h3>
            <ng-container *ngTemplateOutlet="searchInputAndLocation"></ng-container>
            <div #container
                 class="overflow-y-auto flex flex-column flex-grow">
            </div>
            <div class="flex flex-row m-t b-b m-b-2 col-12">
                <div class="p-t-4 p-b-2 p-l-3 p-r-3 b-w-2 b-b b-col-1 p2"
                     [class.b-col-t]="!isMapVisible"
                     (click)="isMapVisible=true">{{'Map' | translate}}</div>
                <div class="p-t-4 p-b-2 p-l-3 p-r-3 b-w-2 b-b b-col-1 p2"
                     [class.b-col-t]="isMapVisible"
                     (click)="isMapVisible=false">{{'List' | translate}}</div>
            </div>
            @switch (isMapVisible) {
            @case (true) {
            <!-- map -->
            <div class="ratio-2-3">
                <google-map class="fill"
                            [fitBounds]="true"
                            [stores]="findableModels"
                            [markerLimit]="isUserSearch ? showLimit : 1000">
                </google-map>
            </div>
            }
            <!-- shop list -->
            @default {
            <ng-container *ngTemplateOutlet="searchResults"></ng-container>
            }
            }
        </div>
    </ng-container>
    <ng-template #searchResults>
        <div class="w-12 p-b-4 flex flex-justify-between flex-middle">
            <p class="p2 w-6 w-12-s w-12-m p-t-5 p-t-3-m p-b-3-m m-t-7-m m-b-2-m ">
                {{(findableModels?.length === 1 ? '% result found' : '% results found') | translate :
                (findableModels?.length || 0)}}</p>
        </div>
        @for (store of findableModels; track $index) {
        <div class="b-b p-t-6 p-b-6 flex flex-column m-t-2"
             [attr.id]="'store-' + store.id">
            <div class="pos-relative flex flex-justify-between">
                <span class="s1">{{store.data.store_name}}</span>
                <div class="p-r-2">
                    <button type="button p-a"
                            (click)="showStoreModal(store)"
                            aria-label="Show modal">
                        <i class="icon-i"
                           aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <p class="p1 p-t-1 col-12">{{store.data.address}}</p>
            <p class="p1 p-t-1 col-12">{{store.data.city}}, {{store.data.postcode}}</p>
            <store-open-status [store]="store"></store-open-status>
        </div>
        }
    </ng-template>

    <ng-template #searchInputAndLocation>
        <form #form="ngForm"
              method="POST"
              novalidate="true">
            <input-wrap>
                <select class="select w-8 w-12-m w-12-s"
                        name="country"
                        [(ngModel)]="country"
                        (change)="search()"
                        [muiInput]="''"
                        (keydown.enter)="search()">

                    <option [ngValue]="undefined">{{ 'Please Select a Country' | translate }}</option>

                    @for (item of countries; track $index) {
                    <option [ngValue]="item.code">{{item.name}}</option>
                    }
                </select>
            </input-wrap>
            <div>
                <div class="m-t">
                    <div class="w-8 w-12-s pos-relative input-wrapper">
                        <input-wrap>
                            <input class="input"
                                   name="address"
                                   type="text"
                                   #addressInput
                                   [attr.placeholder]="isFocus ? 'Town, city, postcode' : 'Town, city, postcode' | translate"
                                   [(ngModel)]="address"
                                   (keyup)="keyup($event)">
                        </input-wrap>
                        <action class="search-icon pos-absolute top-50 right-0 flex flex-middle p-r-4"
                                [status]="status"
                                (click)="search()"
                                aria-label="Search">
                            <i class="fs-7 icon-search"
                               aria-hidden="true">
                            </i>
                        </action>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</div>